import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import CustomerSuccessMeets from '../components/CustomerSuccessMeets'

export default function HowRenewalIntelligenceWinsAgainstTheOdds() {
  return (
    <div>
      <Header1/>
      <CustomerSuccessMeets/>
      <Footer/>
    </div>
  )
}
